import type { ReactElement } from 'react';

/* A section heading over a 2px rule, with an optional control on its baseline.
 *
 * **The reference design's one structural device**, and the reason it lives here rather than in a
 * feature is that this is its third consumer. Alert routing worked the shape out first, access policy
 * copied it, and reconciliation would have been the third identical eleven-line component — which is
 * the two-vocabularies class CLAUDE.md §9 records at five sites, in the one place where being subtly
 * wrong is invisible: a heading 2px lighter on one screen than the next reads as a different kind of
 * boundary, and nobody can say which of the three is the intended one.
 *
 * Deliberately not `PageHeader`. That component owns the page's single `h1` and its lede; this is an
 * `h2` over a rule, dividing one page into the sections a reader stops at. A screen has one of the
 * first and several of the second.
 */

export interface SectionHeadProps {
  readonly title: string;
  /** A control on the heading's baseline — the accent button, or `.lq-sect__ghost`.
   *
   * `| undefined` explicitly: `exactOptionalPropertyTypes` is on, so a caller forwarding a
   * conditional cannot pass explicit undefined to a bare `action?: ReactElement`. */
  readonly action?: ReactElement | undefined;
}

export function SectionHead({ title, action }: SectionHeadProps): ReactElement {
  return (
    <div className="lq-sect">
      <h2 className="lq-sect__title">{title}</h2>
      {action}
    </div>
  );
}
